import Loadable from "app/components/Loadable";
import { lazy } from "react";

const AgentTemplateListPage = Loadable(lazy(() => import("./AgentTemplateListPage")));
const AgentFormPage = Loadable(lazy(() => import("app/views/agent/AgentFormPage")));

const sysadminAgentTemplateRoutes = [
  { path: "sysadmin/agent-templates", element: <AgentTemplateListPage /> },
  { path: "sysadmin/agent-templates/:id", element: <AgentFormPage sysadmin /> },
];

export default sysadminAgentTemplateRoutes;
